export default ({ Schema }) => {
  return new Schema(
    {
      name: { type: String, required: true },
      age: { type: Number },
      gender: { type: String, enum: ['Male', 'Female', 'Other'] },
      foo: {
        bar: { type: Number },
      },
    },
    { timestamps: true }
  )
}
